import { render, staticRenderFns } from "./BsPopover.vue?vue&type=template&id=d54bcece&"
import script from "./BsPopover.vue?vue&type=script&lang=js&"
export * from "./BsPopover.vue?vue&type=script&lang=js&"
import style0 from "./BsPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports